import styled, { css } from 'styled-components';
import { getGridPadding, breakpointWithOffset, GRID_MAX_WIDTH } from '../Grid/styles.js';
import { boxStyles } from '../Box/styles.js';
import { styledContentText } from '../ContentText/styles.web.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';
import { generateBoxPropStyles } from '../Box/utils.js';

var contentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__contentWrapper",
  componentId: "sc-kswcp4-0"
})(["display:flex;align-items:flex-start;flex:1;", "{color:", ";}padding:", ";"], styledContentText, function (p) {
  return p.$textColor;
}, function (p) {
  return "".concat(p.theme.notification.web.paddingVertical, " ").concat(p.theme.notification.web.paddingHorizontal);
});
var gridPaddingStyles = /*#__PURE__*/css(["padding-left:", ";padding-right:", ";", "{padding-left:", ";padding-right:", ";}", "{padding-left:", ";padding-right:", ";}", "{padding-left:", ";padding-right:", ";}", "{padding-left:", ";padding-right:", ";}", "{padding-left:", ";padding-right:", ";}", "{padding-left:", ";padding-right:", ";", "{max-width:", ";}}"], getGridPadding('xxs'), getGridPadding('xxs'), breakpointWithOffset('xs'), getGridPadding('xs'), getGridPadding('xs'), breakpointWithOffset('s'), getGridPadding('s'), getGridPadding('s'), breakpointWithOffset('m'), getGridPadding('m'), getGridPadding('m'), breakpointWithOffset('l'), getGridPadding('l'), getGridPadding('l'), breakpointWithOffset('xl'), getGridPadding('xl'), getGridPadding('xl'), breakpointWithOffset('xxl'), getGridPadding('xxl'), getGridPadding('xxl'), contentWrapper, GRID_MAX_WIDTH);
var outerContainer = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__outerContainer",
  componentId: "sc-kswcp4-1"
})(["display:flex;justify-content:center;box-sizing:border-box;", " ", ";"], function (p) {
  return p.$contentFollowsGrid ? gridPaddingStyles : undefined;
}, boxStyles);
/**
 * The CSS involved in this component uses non-standard but
 * widely supported properties (last n of Safari, FF, Chrome 02/2024)
 */
var textContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__textContainer",
  componentId: "sc-kswcp4-2"
})(["", ""], function (p) {
  return p.$isExpanded ? '' : css(["display:-webkit-box;-webkit-box-orient:vertical;text-overflow:ellipsis;overflow:hidden;", " ", ""], generateBoxPropStyles('-webkit-line-clamp', p.$numberOfLines), generateBoxPropStyles('line-clamp', p.$numberOfLines));
});

export { contentWrapper, outerContainer, textContainer };
